import React from 'react';
import { FormattedMessage } from 'react-intl';

import { useBreakpoints } from '@/hooks';
import { ExtendedContactUser } from '@/types';

import Contact from '../contact';

import * as S from './first-degree-contact.styles';

type Props = {
  entryPoint: string;
  hint?: string | null;
  messengerContextId: string;
  user?: ExtendedContactUser | null;
  isCommonContact?: boolean;
};

const FirstDegreeContact: React.FC<Props> = ({
  user,
  hint,
  messengerContextId,
  entryPoint,
  isCommonContact = false,
}) => {
  const { isMobile } = useBreakpoints();

  const handleMessageClick = (): void => {
    if (user?.slug) {
      window.location.assign(`/chats/new/${user?.slug}?contextId=${messengerContextId}&entryPoint=${entryPoint}`);
    }
  };

  return (
    <div>
      <Contact user={user} hint={hint} connectionDegree={1} isCommonContact={isCommonContact} />
      {!isMobile ? (
        <S.MessageButton
          size="small"
          variant="secondary"
          onClick={handleMessageClick}
          data-soft-login-fenced
          data-testid="company-contact-message"
        >
          <FormattedMessage id="JOBS_DETAIL_COMPANY_CONTACT_MESSAGE" />
        </S.MessageButton>
      ) : null}
    </div>
  );
};

export default FirstDegreeContact;
